var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'is-active': _vm.isOpened}},[_c('div',{staticClass:"v-accordion-item__top",on:{"click":_vm.onClick}},[_vm._t("title",null,{isExpanded:_vm.isOpened})],2),_vm._v(" "),_c('div',{staticClass:"v-accordion-item__content",style:({'height': _vm.isOpened ? 'auto' : '0', 'overflow': 'hidden'})},[_vm._t("content",null,{isExpanded:_vm.isOpened})],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac214920","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccordionItem.vue
// module id = 310
// module chunks = 0